import { CommonModule } from '@angular/common';
import { LoadingOverlayComponent } from './loading-overlay.component';
import { NgModule } from '@angular/core';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';

@NgModule({
  declarations: [LoadingOverlayComponent],
  imports: [CommonModule, ProgressSpinnerComponent],
  exports: [LoadingOverlayComponent],
})
export class LoadingOverlayModule {}
